module.exports = __webpack_public_path__ + "static/media/namasthe-andhra.8ba2a6ac.png";